import { Component, Input } from '@angular/core';
import { RapidReviewTestFormattedResponse } from '@shared/component/rapid-review-modal/rapid-review-modal.service';

@Component({
	selector: 'pms-rapid-review-test',
	templateUrl: './rapid-review-test.component.html',
	imports: [],
})
export class RapidReviewTestComponent {

	@Input({required: true})
	test: RapidReviewTestFormattedResponse;
}
